// extracted by mini-css-extract-plugin
export default {"dateInput":"TabDue_dateInput__nkUkc","dataInput":"TabDue_dataInput__xaz2q","dataInputDisabled":"TabDue_dataInputDisabled__8J32S","helperText":"TabDue_helperText__R+foH"};